import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import {
  IPolicyHolderAgeConfig,
  ITravelDurationConfig,
  ITravelRestrictionConfig,
  QuoteType,
} from '@nibtravel/shared/util/models';
import { Observable } from 'rxjs';
import { share, tap } from 'rxjs/operators';

import {
  defaultQuoteConfig,
  IQuoteConfigWithMaps,
  QuoteConfigStateModel,
} from '../models/quote-config.interfaces';
import { QuoteConfigDataService } from '../quote-config.data-service';
import { LoadQuoteConfig } from './quote-config.action';

@State<QuoteConfigStateModel>({
  name: 'quoteConfig',
  defaults: defaultQuoteConfig,
})
@Injectable()
export class QuoteConfigState {
  constructor(private quoteConfigService: QuoteConfigDataService) {}

  @Selector()
  public static policyHolderConfig(
    state: QuoteConfigStateModel,
    country: string,
    quoteType: QuoteType
  ): IPolicyHolderAgeConfig {
    return state[quoteType].policyHolderAgeConfigsMap[country];
  }

  @Selector()
  public static travelDurationConfigs(
    state: QuoteConfigStateModel,
    quoteType: QuoteType
  ): Record<string, ITravelDurationConfig> {
    return state[quoteType].travelDurationConfigsMap;
  }

  @Selector()
  public static travelRestrictions(
    state: QuoteConfigStateModel,
    quoteType: QuoteType
  ): (homeCountry: string) => ITravelRestrictionConfig {
    return (homeCountry: string) =>
      state[quoteType].travelRestrictionConfigsMap[homeCountry];
  }

  @Selector()
  public static getState(
    state: QuoteConfigStateModel,
    quoteType: QuoteType
  ): IQuoteConfigWithMaps {
    return state[quoteType];
  }

  /**
   * Action handler to fetch the quoteConfig using quoteConfig service and stored in Store
   * @param ctx
   * @param brand
   */
  @Action(LoadQuoteConfig)
  loadQuoteConfig(
    ctx: StateContext<QuoteConfigStateModel>,
    { brand }: LoadQuoteConfig
  ): Observable<QuoteConfigStateModel> {
    return this.quoteConfigService.getQuoteConfig(brand).pipe(
      tap((quoteConfigMap: QuoteConfigStateModel) => {
        ctx.setState(patch({ ...quoteConfigMap }));
      }),
      share()
    );
  }
}
